"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _system = require("@mui/system");
const memoTheme = _system.unstable_memoTheme;
var _default = exports.default = memoTheme;
